import { Component, HostBinding } from '@angular/core';
import {
    trigger,
    state,
    style,
    animate,
    transition,
    // ...
} from '@angular/animations';

const submitBtnAnimation = trigger('slide-down', [
    state('up', style({ transform: 'translateY(0%)' })),
    state('down', style({ transform: 'translateY(95%)' })),

    transition('up => down', [
        animate('.3s cubic-bezier(.99,.01,0,.99)')
    ]),

    transition('down => up', [
        animate('.3s 1.1s cubic-bezier(.99,.01,0,.99)')
    ]),
]);



export { submitBtnAnimation };